import React from 'react'
import { ServicesCard } from './index'

const Services = () => {
    const data = [
        {
            'to':'/',
            'title':'Denetim Hizmetleri',
            'desc':'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
            'icon':'far fa-clock'
        },
        {
            'to':'/',
            'title':'Finansal Hizmetleri',
            'desc':'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
            'icon':'fas fa-money-check-alt'
        },
        {
            'to':'/',
            'title':'Kosgeb Hizmetleri',
            'desc':'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
            'icon':'far fa-file-alt'
        },
        {
            'to':'/',
            'title':'Muhasebe Hizmetleri',
            'desc':'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
            'icon':'fas fa-hand-holding-usd'
        },
    ]

    return (
        <div className="landing-container-services">
            <h1>Hizmetlerimiz</h1>
            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
            <div className="landing-container-services-list">
                {
                    data.map((d, id) => (
                        <ServicesCard
                            key     = { id      }   
                            to      = { d.to    }
                            title   = { d.title }
                            desc    = { d.desc  }
                            icon    = { d.icon  }
                        />
                    ))
                }
            </div>
        </div>
    )
}

export default Services
